import IconHome from '@mui/icons-material/Home';
import { AppMenuItem } from './types';

export const appMenuItemDefinitions: Array<AppMenuItem> = [
  {
    name: 'Events',
    link: '/events',
    Icon: IconHome,
    RequireAdmin: false,
  },
  {
    name: 'Om...',
    link: '/about',
    RequireAdmin: false,
  },
  {
    name: 'Kontakt',
    link: '/contact',
    RequireAdmin: false,
  },
  {
    name: 'Events admin',
    link: '/admin/events',
    RequireAdmin: true,
  },
  {
    name: 'Shop admin',
    link: '/admin/shop',
    RequireAdmin: true,
  },
  {
    name: 'Download Jobs',
    link: '/admin/download-jobs',
    RequireAdmin: true,
  },
  {
    name: 'System Config',
    link: '/admin/systemconfig',
    RequireAdmin: true,
  },
  {
    name: 'fmork.net',
    link: 'https://www.fmork.net',
    RequireAdmin: false,
  },
  {
    name: 'photosbyfmork.com',
    link: 'https://www.photosbyfmork.com',
    RequireAdmin: false,
  },
];
